import { Status, StatusOption } from 'types/cabinetCopying';

export const statusOptions: StatusOption[] = [
  { value: Status.IN_PROGRESS, label: 'In progress', badge: 'warning' },
  { value: Status.COMPLETE, label: 'Complete', badge: 'success' },
  { value: Status.ERROR, label: 'Error', badge: 'danger' },
];
